import {
  LayoutDashboard, Users,
  Calendar, Layers,
  MessageSquare, GitBranch, Megaphone, BarChart3,
  Settings, type LucideIcon
} from 'lucide-react'

export interface NavItem {
  label: string
  path: string
  icon: LucideIcon
  badge?: number
}

export const navItems: NavItem[] = [
  { label: 'Dashboard',    path: '/dashboard',    icon: LayoutDashboard },
  { label: 'Customers',    path: '/customers',    icon: Users },
  { label: 'Work',         path: '/work',         icon: Layers },
  { label: 'Calendar',     path: '/calendar',     icon: Calendar },
  { label: 'Inbox',        path: '/inbox',        icon: MessageSquare },
  { label: 'Workflows',    path: '/workflows',    icon: GitBranch },
  { label: 'Marketing',    path: '/marketing',    icon: Megaphone },
  { label: 'Reports',      path: '/reports',      icon: BarChart3 },
  { label: 'Settings',     path: '/settings',     icon: Settings },
]
